import tournament from './tournament'
export default {
  tournament
}
